import React from 'react';
import { AppRoute } from '../../types';
import { UserList, QuizList, AlgorithmView } from '../views';
export const adminRoutes: AppRoute[] = [
  {
    title: 'Users',
    path: '/admin/users',
    primary: true,
    external: false,
    component: <UserList />,
  },
  {
    title: 'Quizzes',
    path: '/admin/quizzes',
    primary: true,
    external: false,
    component: <QuizList />,
  },
  {
    title: 'Algorithm',
    path: '/admin/algorithm',
    primary: true,
    external: false,
    component: <AlgorithmView />,
  },
];
